/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `ExecutiveCommandView.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { ExecutiveCommandView } from "./ExecutiveCommandView";

import { ExecutiveCommandSection } from "./ExecutiveCommandSection";
import { Team } from "./Team";
import { User } from "./User";

export abstract class ExecutiveCommandViewModel {
    id: number;
    createdAt: Dayjs;
    name: string;
    teamId: number;
    updatedAt: Dayjs;
    userId: number;
    executiveCommandSections: ExecutiveCommandSection[] | undefined;
    team: Team | null | undefined;
    user: User | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        createdAt: Dayjs,
        name: string,
        teamId: number,
        updatedAt: Dayjs,
        userId: number,
        executiveCommandSections: ExecutiveCommandSection[] | undefined,
        team: Team | null | undefined,
        user: User | null | undefined
    ) {
        this.id = id;
        this.createdAt = createdAt;
        this.name = name;
        this.teamId = teamId;
        this.updatedAt = updatedAt;
        this.userId = userId;
        this.executiveCommandSections = executiveCommandSections;
        this.team = team;
        this.user = user;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): ExecutiveCommandView {
        const newObject = new ExecutiveCommandView(
            json["id"],
            dayjs(json["created_at"]).tz(timezone),
            json["name"],
            json["team_id"],
            dayjs(json["updated_at"]).tz(timezone),
            json["user_id"],
            json["executive_command_sections"]?.map((item: any) =>
                ExecutiveCommandSection.fromApiObject(item, timezone)
            ),
            json["team"] == null ? json["team"] : Team.fromApiObject(json["team"], timezone),
            json["user"] == null ? json["user"] : User.fromApiObject(json["user"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(visited = new Set<any>()): any {
        if (visited.has(this)) {
            // Return null, undefined, or primary key to break the cycle
            return undefined;
        }
        visited.add(this);

        return {
            id: this.id,
            created_at: this.createdAt,
            name: this.name,
            team_id: this.teamId,
            updated_at: this.updatedAt,
            user_id: this.userId,
            executive_command_sections_attributes: this.executiveCommandSections
                ?.map((item) => item.toApiObject(visited))
                .filter((item) => item !== undefined),
            team_attributes: this.team?.toApiObject(visited),
            user_attributes: this.user?.toApiObject(visited),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): ExecutiveCommandView {
        const clone = Object.create(this) as ExecutiveCommandView;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
